import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import One from './pages/one'
import Two from './pages/two'


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/one" element={<One />} />
        <Route path="/" element={<Two />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App